<div class="anm-backdrop" [class.anm-backdrop--embedded]="embedded" (click)="close()">
  <!-- Screen-origin particles (the default): thrown over the whole page around the popup.
       pointer-events: none, so the backdrop click-to-close still works through it. -->
  <app-announcement-particles
    *ngIf="screenEffects as fx"
    class="anm-particles anm-particles--screen"
    [effects]="fx"
    [accent]="theme.accent"
    [loop]="previewMode"
  ></app-announcement-particles>

  <div class="anm-modal" [class.anm-modal--simple]="!isTwoPane"
        [style.background]="theme.panelBg" [style.color]="theme.panelText"
        (click)="$event.stopPropagation()">
   <!-- Card-origin particles: play inside the popup, clipped by its rounded corners. -->
   <app-announcement-particles
     *ngIf="cardEffects as fx"
     class="anm-particles"
     [effects]="fx"
     [accent]="theme.accent"
     [loop]="previewMode"
   ></app-announcement-particles>
   <!-- Simple card has no right pane to hang the close button off, and .anm-simple-body
        starts below the title — pinning it there put the cross halfway down the card.
        Anchor it to the modal itself so it sits in the same corner as the two-pane one. -->
   <button
     type="button"
     class="anm-close-corner"
     *ngIf="!isTwoPane"
     (click)="close()"
     [attr.aria-label]="'APP_BUTTONS.CLOSE' | translate"
   >
     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>
   </button>

   <div class="anm-panes">
    <div class="anm-left" [style.background]="theme.panelBg" [style.color]="theme.panelText">
      <div class="anm-left__head">
        <img src="assets/iconLogo.png" alt="" class="anm-left__logo" />
        <h2 class="anm-left__title" [style.color]="theme.panelText">
          {{ text(announcement.title) || ("ANNOUNCEMENT.WHATS_NEW.TITLE" | translate) }}
        </h2>
        <p class="anm-left__subtitle" *ngIf="text(announcement.subtitle)" [style.color]="theme.panelText">
          {{ text(announcement.subtitle) }}
        </p>
      </div>

      <!-- Accordion: exactly one card is expanded; clicking another collapses this one. -->
      <div class="anm-list" *ngIf="isTwoPane">
        <div
          class="anm-card"
          *ngFor="let feature of features; let i = index"
          [class.anm-card--open]="i === selectedIndex"
        >
          <button type="button" class="anm-card__head" (click)="select(i, $event)">
            <span class="anm-card__icon" *ngIf="feature.iconValue" [style.background]="iconBg(feature)">
              <img [src]="feature.iconValue" alt="" [style.filter]="iconFilter(feature)" />
            </span>
            <span class="anm-card__title" [style.color]="theme.panelText">{{ text(feature.title) }}</span>
            <span class="anm-tag" *ngIf="feature.tagLabel" [class]="'anm-tag--' + (feature.tagTone || 'NEUTRAL')">
              {{ text(feature.tagLabel) }}
            </span>
            <svg class="anm-card__chevron" [class.anm-card__chevron--open]="i === selectedIndex"
                 width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
          </button>

          <div class="anm-card__panel" *ngIf="i === selectedIndex">
            <p class="anm-card__description" [style.color]="theme.panelText">{{ text(feature.description) }}</p>
            <button
              type="button"
              class="anm-cta"
              *ngIf="feature.ctaType !== 'NONE'"
              [style.background]="theme.accent"
              [style.color]="theme.accentText"
              (click)="onCtaClick(feature)"
            >
              {{ text(feature.ctaLabel) || ("APP_BUTTONS.OK" | translate) }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="anm-right" *ngIf="isTwoPane" [style.background]="theme.previewBg">
      <button type="button" class="anm-right__close" (click)="close()" [attr.aria-label]="'APP_BUTTONS.CLOSE' | translate">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>
      </button>

      <ng-container [ngSwitch]="selectedFeature?.previewMediaType">
        <img *ngSwitchCase="'IMAGE'" [src]="selectedFeature?.previewMediaUrl" class="anm-right__media" alt="" />
        <img *ngSwitchCase="'GIF'" [src]="selectedFeature?.previewMediaUrl" class="anm-right__media" alt="" />
        <video *ngSwitchCase="'VIDEO'" [src]="selectedFeature?.previewMediaUrl" class="anm-right__media" controls autoplay muted loop></video>
        <div *ngSwitchDefault class="anm-right__placeholder">
          <p>{{ text(selectedFeature?.description) }}</p>
        </div>
      </ng-container>
    </div>

    <div class="anm-simple-body" *ngIf="!isTwoPane">
      <p class="anm-simple-body__description" [style.color]="theme.panelText">{{ text(selectedFeature?.description) }}</p>
      <button
        type="button"
        class="anm-cta"
        *ngIf="selectedFeature?.ctaType !== 'NONE'"
        [style.background]="theme.accent"
        [style.color]="theme.accentText"
        (click)="onCtaClick(selectedFeature!)"
      >
        {{ text(selectedFeature?.ctaLabel) || ("APP_BUTTONS.OK" | translate) }}
      </button>
    </div>
   </div>

    <!-- Footer bar, spanning both panes -->
    <div class="anm-footer" *ngIf="footer as f" [style.color]="footerText" [style.background]="footerBg">
      <span class="anm-footer__icon" *ngIf="f.iconValue" [style.background]="footerIconBg">
        <img [src]="f.iconValue" alt="" [style.filter]="footerIconFilter" />
      </span>
      <span class="anm-footer__text">
        <b [class.anm-footer__ph]="!text(f.text)">{{ text(f.text) || footerPlaceholder }}</b>
        <span *ngIf="text(f.note)">{{ text(f.note) }}</span>
      </span>
      <button type="button" class="anm-footer__link" *ngIf="text(f.linkLabel)"
              [style.color]="theme.accent" (click)="onFooterLinkClick()">
        {{ text(f.linkLabel) }}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6"/><path d="M10 14 21 3"/></svg>
      </button>
    </div>
  </div>
</div>
